import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Logo = function(_param) {
    var isDark = _param.isDark, props = _object_without_properties(_param, [
        "isDark"
    ]);
    var textColor = isDark ? "#FFFFFF" : "#000000";
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 198 199"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "99",
                cy: "99",
                r: "85",
                fill: "black",
                stroke: "white",
                strokeWidth: "10"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "55",
                cy: "100",
                r: "12",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "99",
                cy: "100",
                r: "12",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "143",
                cy: "100",
                r: "12",
                fill: "white"
            })
        ]
    }));
};
export default /*#__PURE__*/ React.memo(Logo, function(prev, next) {
    return prev.isDark === next.isDark;
});
